// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"384":"42a1edbf566603f8","628":"0af76f8efc1a9f1e"}[chunkId] + ".js";
};